export const CLOSE_IFRAME = 'CLOSE_IFRAME';

export interface CloseIframeMessage {
    type: typeof CLOSE_IFRAME;
}
